export const DUEL_LOGO = require('./duel-logo.png');
